import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { useSessionData } from '@confluence/session-data';

import { TRY_CONFLUENCE_ROUTE } from '../constants';
import { getWacDomain } from '../linkUtils';
import { useWithButtonAnalytics } from '../hooks/useWithButtonAnalytics';

const fullMessage = (
	<FormattedMessage
		id="external-share.try-confluence.button"
		description="button label text for a CTA to sign up for a free website instance"
		defaultMessage="Try Confluence for free"
	/>
);

const shortMessage = (
	<FormattedMessage
		id="external-share.try-confluence.button.shortened"
		description="shortened button label text for a CTA to sign up for a free website instance"
		defaultMessage="Try for free"
	/>
);

export const TryButton: FC<{
	contentId: string;
	spaceKey?: string | null;
	renderLocation: string;
	shortened?: boolean;
	contentType?: string | null;
}> = ({ contentId, renderLocation, shortened, contentType }) => {
	const { environment } = useSessionData();

	const { sendButtonUIEvent } = useWithButtonAnalytics({
		actionSubjectId: 'tryConfluenceButton',
		contentId,
		renderLocation,
		contentType,
	});

	const WAC_DOMAIN = getWacDomain(environment);

	const TRY_CONFLUENCE_URL = `${WAC_DOMAIN}${TRY_CONFLUENCE_ROUTE}`;

	return (
		<Button
			href={TRY_CONFLUENCE_URL}
			onClick={sendButtonUIEvent}
			appearance="primary"
			target="_blank"
		>
			{shortened ? shortMessage : fullMessage}
		</Button>
	);
};
